import axios from 'axios';
import { resolveCrmContactEmail } from '@rta/rta-blueprint-library';

export type CrmLoadProjectParams = {
	// data
	email: string,
	useTestContact?: boolean,
	// token
	getToken: () => Promise<string>,
	// callbacks
	setState?: (data: any) => void,
	setError?: (error: string) => void
};

export const crmLoadProject = async (params: CrmLoadProjectParams): Promise<[any, string | null]> => {
	// eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
	const { email, useTestContact = false, getToken, setState, setError } = params;

	const projectEmail = resolveCrmContactEmail({ realEmail: email, environment: import.meta.env.VITE_APP_ENVIRONMENT, useTestContact });

	try {
		const token = await getToken();
		const response = await axios.get(`${import.meta.env.VITE_API_URL}/project/${projectEmail}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		if (response.status !== 200) {
			if (setError) setError(response.data);
			return [null, response.data];
		}

		if (setState) setState(response.data);
		return [response.data, null];
	} catch (error) {
		const message = error instanceof Error ? error.message : String(error);
		if (setError) setError(message);
		return [null, message];
	}

	return [null, null];
};
